import { departmentService } from "../../../../Api/Services/DepartmentService";
import { ACTION_NAMES, SLICE_NAMES } from "../../../../constants/action";
import { ERROR_MESSAGES } from "../../../../constants/error";
import { Nullable } from "../../../../Types/Common";
import createGenericSlice from "../../../../utils/reduxUtils/createEntitySlice";
import createServiceAsyncThunk from "../../../../utils/reduxUtils/createServiceAsyncThunk";

export const createDepartmentCategory = createServiceAsyncThunk<any, any>(
  ACTION_NAMES.CREATE_DEPARTMENT_CATEGORY,
  ({
    id,
    name,
    is_active,
    parent_id,
    node_level,
    description,
    department_id,
  }: {
    department_id: number;
    name: string;
    parent_id: Nullable<number>;
    node_level: number;
    description: string;
    is_active: boolean;
    id: Nullable<number>;
  }) =>
    departmentService.createDepartmentTasks({
      id,
      name,
      is_active,
      parent_id,
      node_level,
      description,
      department_id,
    }),
  ERROR_MESSAGES.CREATE_DEPARTMENT_CATEGORY_FAILURE
);

const createDepartmentCategortSlice = createGenericSlice<any, any>(
  SLICE_NAMES.CREATE_DEPARTMENT_TASK_SLICE,
  createDepartmentCategory
);

export const {
  clearError: clearCreateDepartmentCategoryError,
  clearSuccessMessage: clearCreateDepartmentCategorySuccess,
} = createDepartmentCategortSlice.actions;

export default createDepartmentCategortSlice.reducer;
